<template>
  <div class="min-h-screen bg-background font-sans selection:bg-primary/10">

    <main class="pt-32 pb-20 container mx-auto px-4">
      <!-- Hero Section -->
      <transition name="fade-up" appear>
        <div class="text-center mb-16">
          <h1 class="text-4xl md:text-6xl font-serif text-primary mb-6">Contact</h1>
          <p class="max-w-2xl mx-auto text-muted-foreground">
            Get in touch for collaborations, inquiries, or just to say hello.
          </p>
        </div>
      </transition>

      <!-- Contact Section -->
      <section class="grid md:grid-cols-2 gap-12 lg:gap-24 items-start max-w-6xl mx-auto">
        <!-- Contact Info -->
        <div class="space-y-8">
          <div>
            <h2 class="text-3xl font-serif mb-6">Get in Touch</h2>
            <p class="text-muted-foreground leading-relaxed">
              Have questions about commissions, shipping, or upcoming events?
              Feel free to reach out. I'm always open to discussing new projects and creative ideas.
            </p>
          </div>

          <div class="space-y-6">
            <div class="flex items-start gap-4">
              <div class="bg-secondary/50 p-3 rounded-full">
                <i class="fa-regular fa-envelope fs-24"></i>
              </div>
              <div>
                <h3 class="font-medium mb-1">Email</h3>
                <a href="mailto:artpulsebyshruti@gmail.com"
                  class="text-muted-foreground hover:text-primary transition-colors">
                  artpulsebyshruti@gmail.com
                </a>
              </div>
            </div>

            <div class="flex items-start gap-4">
              <div class="bg-secondary/50 p-3 rounded-full">
                <i class="fa fa-phone fs-24"></i>
              </div>
              <div>
                <h3 class="font-medium mb-1">Phone</h3>
                <p class="text-muted-foreground">+1 (480) 636-0819</p>
              </div>
            </div>

            <div class="flex items-start gap-4">
              <div class="bg-secondary/50 p-3 rounded-full">
                <!-- <i class="fa fa-map-marker fs-24"></i> -->
                <i class="fa-duotone fa-solid fa-location-dot fs-24"></i>
              </div>
              <div>
                <h3 class="font-medium mb-1">Studio</h3>
                <p class="text-muted-foreground">
                  2133 west gambit trail,<br /> Phoenix AZ 85085
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="pt-6 border-t border-border">
            <h3 class="font-medium mb-4">Follow ArtPulse</h3>
            <div class="flex gap-4">
              <button class="rounded-full hover:bg-primary hover:text-white transition-colors p-2 border border-gray-300">
                <i class="fa-brands fa-instagram fs-24"></i>
              </button>
              <button class="rounded-full hover:bg-primary hover:text-white transition-colors p-2 border border-gray-300">
                <i class="fa-brands fa-facebook fs-24"></i>
              </button>
            </div>
          </div> -->
          <div class="pt-6 border-t border-border">
            <h3 class="font-medium mb-4">Follow ArtPulse</h3>

            <div class="flex gap-4">
              <a href="https://www.instagram.com/artpulse_by_shruti/" target="_blank" class="inline-flex items-center justify-center rounded-full 
             hover:bg-primary hover:text-black transition-colors 
             p-2 border border-gray-300">
                <i class="fa-brands fa-instagram fs-24"></i>
              </a>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="border-border/50 shadow-sm rounded-lg p-6 bg-white">
          <h2 class="font-serif text-2xl mb-4">Send a Message</h2>
          <form @submit.prevent="handleContactSubmit" class="space-y-4">
            <div class="grid gap-2">
              <label for="contact-name" class="font-medium">Name</label>
              <input id="contact-name" v-model="contactForm.name" required class="border p-2  w-full border-black" />
            </div>
            <div class="grid gap-2">
              <label for="contact-email" class="font-medium">Email</label>
              <input id="contact-email" type="email" v-model="contactForm.email" required
                class="border p-2  w-full border-black" />
            </div>
            <div class="grid gap-2">
              <label for="contact-phone" class="font-medium">Phone Number</label>
              <input id="contact-phone" type="tel" v-model="contactForm.phone_no" required
                class="border p-2  w-full border-black" />
            </div>
            <div class="grid gap-2">
              <label for="contact-message" class="font-medium">Message</label>
              <textarea id="contact-message" class="min-h-[150px] border p-2  w-full border-black"
                v-model="contactForm.message" required></textarea>
            </div>
            <button type="submit" class="w-full bg-green-500 text-white py-3  disabled:opacity-50" :disabled="isSending">
              {{ isSending ? "Sending..." : "Send WhatsApp" }}
            </button>
          </form>
        </div>
      </section>
    </main>

    <!-- Simple Toast Notification -->
    <transition name="fade">
      <div v-if="toast.visible" class="fixed top-5 right-5 bg-green-500 text-white p-4 rounded-lg shadow-lg z-50">
        <p class="font-bold">{{ toast.title }}</p>
        <p>{{ toast.description }}</p>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'ContactPage',
  data() {
    return {
      contactForm: {
        name: '',
        email: '',
        phone_no: '',
        message: '',
      },
      isSending: false,
      toast: {
        visible: false,
        title: '',
        description: '',
      },
    };
  },
  methods: {
    // handleContactSubmit() {
    //   this.isSending = true;
    //   setTimeout(() => {
    //     this.isSending = false;
    //     this.resetForm();
    //     this.showToast("Message Sent", "Thank you for reaching out! We'll get back to you soon.");
    //   }, 1500);
    // },
    handleContactSubmit() {


      if (this.contactForm.email == '' || this.contactForm.email == null) {
        this.showToast("Error", "Please enter your email and phone number.");
        return;
      }
      if (this.contactForm.phone_no == '' || this.contactForm.phone_no == null) {
        this.showToast("Error", "Please enter your email and phone number.");
        return;
      }
      this.isSubmitting = true;
      try {
        const data = {
          heading: "Contact Request",
          name: this.contactForm.name,
          email: this.contactForm.email,
          phone_no: this.contactForm.phone_no,
          message: this.contactForm.message,
        }

        const message = `
                
*${data.heading}*

*User Details*
• Name: ${data.name}
• Email: ${data.email}
• Phone: ${data.phone_no}
• Message: ${data.message}
`

        const encodedMessage = encodeURIComponent(message.trim())

        window.open(
          `https://wa.me/14806360819?text=${encodedMessage}`,
          '_blank'
        )
      } catch (error) {
        console.error(error)
      } finally {
        this.isSubmitting = false;
        this.resetForm();
      }
    },
    resetForm() {
      this.contactForm = { name: '', email: '', phone_no: '', message: '' };
    },
    showToast(title, description) {
      this.toast.title = title;
      this.toast.description = description;
      this.toast.visible = true;
      setTimeout(() => {
        this.toast.visible = false;
      }, 5000);
    },
  },
};
</script>

<style scoped>
.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 0.8s, transform 0.8s;
}

.fade-up-enter-from,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>